export default "__VITE_PUBLIC_ASSET__60d6f31c__"